/* Main JS */

jQuery(document).ready(function($) {

  /* Preloader */
  setTimeout(function(){
    $('body').addClass('loaded');
  }, 1500);

  function workBulletsPosition() {
    if (window.matchMedia('(max-width: 639px)').matches) {
      setTimeout(function(){
        $('#fp-nav').animate({right: '-3px'}, 500);
      }, 2000);
    } else {
      setTimeout(function(){
        $('#fp-nav').animate({right: '11px'}, 500);
      }, 2000);
    }
  }

  workBulletsPosition();

  window.onresize = function() {
    workBulletsPosition();
  }

  /* Work Archive URL */
  var loc = window.location.href; // returns the full URL
  if(/work/.test(loc)) {
    $('.top-bar-right li:first-child').addClass('active');
  }

  /* About Us */
  $('.paragraph .show-more').click(function() {
      if($(this).siblings('.show-more-snippet').css('height') != '57px'){
          $(this).siblings('.show-more-snippet').stop().animate({height: '57px'}, 500);
          $(this).siblings('.arrow-close').css('display', 'none');
          $(this).text('Read on >');
          $([document.documentElement, document.body]).animate({
            scrollTop: $(this).parent().parent('.picture-card').offset().top -20
          }, 1000);
      }else{
          $(this).siblings('.show-more-snippet').css({height:'100%'});
          var card = $(this).siblings('.show-more-snippet').height();
          $(this).siblings('.show-more-snippet').css({height:'57px'});
          $(this).siblings('.show-more-snippet').stop().animate({height: card}, 500);
          $(this).siblings('.arrow-close').css('display', 'block');
          $(this).text('');
          $([document.documentElement, document.body]).animate({
            scrollTop: $(this).parent().siblings('h2').offset().top -20
          }, 1000);
      }
  });

  $('.about-us .arrow-close').click(function(){
    $(this).siblings('.show-more-snippet').stop().animate({height: '57px'}, 500);
    $(this).css('display', 'none');
    $(this).siblings('.show-more').text('Read on >');
    $([document.documentElement, document.body]).animate({
      scrollTop: $(this).parent().parent('.picture-card').offset().top -20
    }, 1000);
  });

  /* News */
  $('.news-title .show-more').click(function() {
      if($(this).siblings('.paragraph').css('height') != '0px'){
          $(this).siblings('.paragraph').stop().animate({height: '0px'}, 500);
          $(this).text('read on');
          $([document.documentElement, document.body]).animate({
            scrollTop: $(this).parent('.picture-card').offset().top
          }, 1000);
      }else{
          $(this).siblings('.paragraph').css({height:'100vh'});
          var card = $(this).siblings('.paragraph').height();
          $(this).siblings('.paragraph').css({height:'0px'});
          $(this).siblings('.paragraph').stop().animate({height: '100vh'}, 500);
          $(this).text('read less');
          $([document.documentElement, document.body]).animate({
            scrollTop: $(this).siblings('.paragraph').offset().top
          }, 1000);
      }
  });

  $('.news .arrow-close').click(function(){
    $(this).parent('.paragraph').stop().animate({height: '0px'}, 1000);
    $(this).parent('.paragraph').siblings('.show-more').text('read on');
    $([document.documentElement, document.body]).animate({
      scrollTop: $(this).parent().parent().parent('.picture-card').offset().top
    }, 1000);
  });
});